import React, { memo } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import * as S from './style';

interface IProps {
  imgSrc?: string;
  total?: number;
  className?: string;
  rs?: string;
  priority?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const RelatedPrdItem = ({
  total,
  imgSrc,
  className,
  rs,
  priority,
  onClick,
}: IProps) => {
  const cName = classNameBind(['relatedprd-item', className || '']);
  const useTotal = !!(total && total > 0);
  return (
    <S.RelatedPrdItem className={cName} onClick={onClick}>
      {useTotal && (
        <div className="total">
          <Text>+{total}</Text>
          <Text>더보기</Text>
        </div>
      )}
      <Img
        className="thumbnail"
        src={getResizeImageUrl(imgSrc, rs)}
        priority={priority}
      />
    </S.RelatedPrdItem>
  );
};

export default memo(RelatedPrdItem);
